import type { DpsMiniAppBackendLbMember } from "@tradingApp/api/types/DpsMiniAppBackend";
import { webAppUserGet } from "@tradingApp/helpers/webApp/userGet";

export function leaderboardCurrentUserDefault():
  | DpsMiniAppBackendLbMember
  | undefined {
  const user = webAppUserGet();

  if (user) {
    return {
      value: undefined,
      rank: undefined,
      user: {
        balance: 0,
        firstName: user.first_name,
        lastName: user.last_name,
        photoUrl: user.photo_url,
      },
    };
  }

  return;
}
